<template>
    <form class="compare-form" @submit.prevent="submit()">
        <div v-for="d in filters" v-if="d.active">
            <label>{{d.name}}</label>
            <div class="form-group">
                <div v-for="c in d.children" class="form-group">
                    <el-select multiple v-model="output[c.id]" :placeholder="'Seleccionar '+c.name" filterable :allow-create="c.allowCreate" default-first-option>
                        <el-option v-for="o in lists[c.id]" :key="o.id" :value="o.id" :label="o.name"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <a href="#" @click.prevent="showAddFilterForm = !showAddFilterForm">Agregar filtro</a>
        <div v-if="showAddFilterForm">
            <div class="row">
                <div class="col-sm-8">
                    <div class="form-group">
                        <el-select v-model="filterForm.filter" placeholder="Seleccione">
                            <el-option v-for="f in filters" v-if="!f.active" :key="f.id" :value="f.id" :label="f.name"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <button type="button" class="btn btn-block btn-secondary" @click.prevent="addFilter()">+</button>
                </div>
            </div>

        </div>
        <button type="submit" class="btn btn-primary btn-block">Filtrar</button>
    </form>
</template>
<style lang="scss">
    .compare-form{
        .el-select{
            display: block;
        }
    }
</style>
<script>
    import _ from 'lodash';
    import axios from 'axios';
    import qs from 'qs';
    import moment from 'moment';

    export default {
        data: function(){
            return {
                output: _.clone(this.query),
                showAddFilterForm: false,
                filterForm:{
                    filter: null
                },
                lists: {},
                filters: [
                    {
                        id: 'type',
                        name: 'Tipo de Gasto',
                        active: false,
                        children: [
                            {
                                id: 'subtitulo',
                                name: 'Subtitulo'
                            }
                        ]
                    },
                    {
                        id: 'institution',
                        name: 'Institución',
                        active: false,
                        children: [
                            {
                                id: 'partida',
                                name: 'Partida'
                            },
                            {
                                id: 'capitulo',
                                name: 'Capitulo'
                            }
                        ]
                    },
                    {
                        id: 'beneficiary',
                        name: 'Beneficiario',
                        active: false,
                        children: [
                            {
                                id: 'beneficiario',
                                name: 'Beneficiario',
                                allowCreate: true
                            }
                        ]
                    },
                    {
                        id: 'time',
                        name: 'Rango de tiempo',
                        active: false,
                        children: [
                            {
                                id: 'periodo',
                                name: 'Periodo'
                            },
                            {
                                id: 'mes',
                                name: 'Mes'
                            }
                        ]
                    }
                ]
            };
        },
        props: ['query'],
        computed:{
            /*
            activeFilters: function(){
                const dimensions = _.map(this.output, (d,key)=>{return key});

                return this.filters.filter((d)=>{
                    return _.find(d.children, (d2)=>{
                        return dimensions.indexOf(d2.id) !== -1;
                    })
                });
            },
            inactiveFilters: function(){
                return this.filters.filter((d)=>{
                    return !_.find(this.activeFilters, {id: d.id});
                })
            }
            */
        },
        watch:{
            'output.periodo':{
                immediate: true,
                handler: function(){
                    this.fetchMeses();
                }
            }
        },
        methods:{
            submit: function(){
                window.location.replace('compare?'+qs.stringify(this.output));
            },
            calculateActiveFilters: function(){
                const dimensions = _.map(this.output, (d,key)=>{return key});

                this.filters.forEach((d)=>{
                    d.active = _.find(d.children, (d2)=>{
                        return dimensions.indexOf(d2.id) !== -1;
                    })
                });
            },
            addFilter: function(){
                const filter = _.find(this.filters, {id: this.filterForm.filter});

                filter.active = true;
                //this.$set(this.output, filter.children[0].id, [0]);
                this.showAddFilterForm = false;
            },
            fetchPeriodos: function(){
                axios.get('api/v1/data/pagos?group-by=["periodo"]')
                    .then((response) => {
                        const items = response.data.map(function(d){
                            return {
                                id: d.periodo,
                                name: d.periodo
                            }
                        });
                        items.unshift({id: 0, name: 'Todas los años'});
                        this.$set(this.lists, 'periodo', items);
                    });
            },
            fetchPartidas: function(){
                axios.get('api/v1/data/pagos?group-by=["partida"]')
                    .then((response) => {
                        const items = response.data.map(function(d){
                            return {
                                id: d.partida,
                                name: d.nombre_partida
                            }
                        });
                        items.unshift({id: 0, name: 'Todas las partidas'});
                        this.$set(this.lists, 'partida', items);
                    });
            },
            fetchSubtitulos: function(){
                axios.get('api/v1/data/pagos?group-by=["subtitulo"]')
                    .then((response) => {
                        const items = response.data.map(function(d){
                            return {
                                id: d.subtitulo,
                                name: d.nombre_subtitulo
                            }
                        });
                        items.unshift({id: 0, name: 'Todos los subtítulos'});
                        this.$set(this.lists, 'subtitulo', items);
                    });
            },
            fetchMeses: function(){
                //if(!this.showMeses)
                //    return this.meses = [];

                axios.get('api/v1/data/pagos',{
                    params:{
                        'group-by': JSON.stringify(['mes']),
                        'where': JSON.stringify({
                            periodo: this.output.periodo
                        })
                    }
                })
                    .then((response) => {
                        const items = response.data.map(function(d){
                            return {
                                id: d.mes,
                                name: moment(d.mes, 'M').format('MMMM')
                            }
                        });
                        items.unshift({id: 0, name: 'Todos los meses'});
                        this.$set(this.lists, 'mes', items);
                    });
            }
        },
        mounted: function(){
            this.calculateActiveFilters();
            this.fetchPartidas();
            this.fetchSubtitulos();
            this.fetchPeriodos();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Forms/Compare.vue